import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./CourseSubjectsUIHelpers";

const CourseSubjectsUIContext = createContext();

export function useCourseSubjectsUIContext() {
  return useContext(CourseSubjectsUIContext);
}

export const CourseSubjectsUIConsumer = CourseSubjectsUIContext.Consumer;

export function CourseSubjectsUIProvider({ courseId, courseSubjectsUIEvents, children }) {  
  initialFilter.filter.courseId = courseId; // Ders Id Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openImportFromExcelDialog: courseSubjectsUIEvents.openImportFromExcelDialog,
    openCourseListPage: courseSubjectsUIEvents.openCourseListPage,
    openSubjectOutcomeListPage: courseSubjectsUIEvents.openSubjectOutcomeListPage,
    openNewCourseSubjectPage: courseSubjectsUIEvents.openNewCourseSubjectPage,
    openEditCourseSubjectPage: courseSubjectsUIEvents.openEditCourseSubjectPage
  };

  return (
    <CourseSubjectsUIContext.Provider value={value}>
      {children}
    </CourseSubjectsUIContext.Provider>
  );
}